import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController } from '@ionic/angular';
import { Md5 } from 'ts-md5';
@Injectable({
  providedIn: 'root'
})
export class HelperService {
  private AlertIsExist = false;
  private LoadingIsExist = false;
  private Loading = null;
  constructor(public alertController: AlertController,
    public loadingController: LoadingController,
    public toastController: ToastController, ) { }

  /**
   * alert弹框，默认只有确定按钮，当存在取消回调函数则会显示取消按钮
   * 注：如果存在打开的alert则不再打开
   * @param header 需要显示的title
   * @param message 需要显示的内容
   * @param okBackFun 成功回调
   * @param cancelBtnFun 失败回调
   */
  alert(header = '', message = '', okBackFun = null, cancelBtnFun = null): void {
    if (this.AlertIsExist) { // alertController.create是异步方法，所以使用AlertIsExist标志是否打开
      setTimeout(() => { // alert关闭的可能性比较多，不止点击确定或取消按钮
        this.AlertIsExist = false;
      }, 10000);
      return;
    }
    this.AlertIsExist = true;
    const buttons = [{
      text: '确定', handler: () => {
        this.AlertIsExist = false;
        okBackFun && okBackFun();
      }
    }];
    if (cancelBtnFun) {
      const cancelBtn = {
        text: '取消',
        role: 'cancel',
        handler: () => {
          this.AlertIsExist = false;
          cancelBtnFun();
        }
      };
      buttons.unshift(cancelBtn);
    }
    this.alertController.create({
      header,
      message,
      buttons
    }).then(alert => alert.present());
  }

  /**
   * 显示提示信息
   */
  toast(message: string = '操作成功', duration: number = 2500, position: 'top' | 'bottom' | 'middle' = 'top'): void {
    const opts = { message, duration, color: 'dark', position, showCloseButton: true, closeButtonText: '✖' };
    this.toastController.create(opts).then(toast => toast.present());
  }

  /**
   * 统一调用此方法显示loading
   */
  showLoading(message: string = '', duration: number = 2000): void {
    if (this.LoadingIsExist) {
      return;
    }
    this.LoadingIsExist = true;
    this.loadingController.create({
      spinner: 'bubbles', // dots https://ionicframework.com/docs/api/spinner
      duration,
      message
    }).then(loading => {
      /**
       * loadingController.create异步方法，调用loading.present()前有可能已经调用hideLoading方法
       * 所以，如果this.LoadingIsExist===false则不打开
       */
      if (this.LoadingIsExist) {
        loading.present();
        this.Loading = loading;
      }
    });
  }

  /**
   * 关闭loading
   */
  hideLoading(): void {
    this.LoadingIsExist = false;
    if (this.Loading) {
      this.Loading.dismiss();
      this.Loading = null;
    }
  }

  md5(str) {
    return Md5.hashStr(str);
  }
}
